import logoLight from '../../assets/images/NUBIP_LOGO_SMALL-08.svg';
import logoDark from '../../assets/images/NUBIP_LOGO_SMALL-08-white.svg';
export const getBrand = (mode = 'light') => ({
  logo: mode === 'dark' ? logoDark : logoLight,
  logoAlt: 'NUBiP Logo',
});

export default getBrand;


